import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
import { useUser } from '~/composables/_next/useUser';
import { useWait } from '~/composables/_next/useWait';
import useLegacySeoMeta from '~/composables/useLegacySeoMeta';
import useRightPath from '~/composables/useRightPath';
import { useCustomerGroup } from '~/composables/useCustomerGroup';
import { randomId } from '~/helpers/randomId';
export default defineComponent({
  name: 'Login',
  components: {},
  setup: function setup() {
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $sentry = _useNuxt2App.$sentry,
      $cookies = _useNuxt2App.$cookies,
      $vsf = _useNuxt2App.$vsf,
      $flag = _useNuxt2App.$flag,
      i18n = _useNuxt2App.i18n;
    var _useUser = useUser(),
      loadUser = _useUser.load,
      user = _useUser.user,
      isAuthenticated = _useUser.isAuthenticated;
    var _useWait = useWait(),
      resetWaiters = _useWait.resetWaiters;
    var _useLegacySeoMeta = useLegacySeoMeta(),
      getMeta = _useLegacySeoMeta.getMeta;
    var _useRightPath = useRightPath(),
      getCanonicalUrl = _useRightPath.getCanonicalUrl;
    var _useCustomerGroup = useCustomerGroup(),
      setCustomerGroup = _useCustomerGroup.setCustomerGroup,
      removeCustomerGroup = _useCustomerGroup.removeCustomerGroup;
    var errored = computed(function () {
      var _app$context;
      return (_app$context = app.context) === null || _app$context === void 0 ? void 0 : _app$context._errored;
    });
    resetWaiters();

    /**
     * Sends context data to sentry.
     */
    function sendSentryContext(user) {
      $sentry === null || $sentry === void 0 ? void 0 : $sentry.setUser({
        id: user === null || user === void 0 ? void 0 : user.id,
        email: user === null || user === void 0 ? void 0 : user.email,
        externalId: user === null || user === void 0 ? void 0 : user.externalId
      });
    }

    /**
     * Sends context data to Tggl.
     */
    function sendTgglContext(user) {
      var _user$id, _user$customerGroup, _i18n$locale, _$vsf$$ct, _$vsf$$ct$config, _$vsf$$ct$config$coun;
      $flag.setContext({
        environment: process.env.CURRENT_ENV,
        userId: (_user$id = user === null || user === void 0 ? void 0 : user.id) !== null && _user$id !== void 0 ? _user$id : $cookies.get('az_uuid'),
        email: user === null || user === void 0 ? void 0 : user.email,
        externalId: user === null || user === void 0 ? void 0 : user.externalId,
        customerGroup: user === null || user === void 0 ? void 0 : (_user$customerGroup = user.customerGroup) === null || _user$customerGroup === void 0 ? void 0 : _user$customerGroup.key,
        locale: (_i18n$locale = i18n.locale) === null || _i18n$locale === void 0 ? void 0 : _i18n$locale.toLowerCase(),
        country: $vsf === null || $vsf === void 0 ? void 0 : (_$vsf$$ct = $vsf.$ct) === null || _$vsf$$ct === void 0 ? void 0 : (_$vsf$$ct$config = _$vsf$$ct.config) === null || _$vsf$$ct$config === void 0 ? void 0 : (_$vsf$$ct$config$coun = _$vsf$$ct$config.country) === null || _$vsf$$ct$config$coun === void 0 ? void 0 : _$vsf$$ct$config$coun.toLowerCase(),
        sessionId: randomId()
      });
    }
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loadUser();
          case 2:
            sendSentryContext(user.value);
            sendTgglContext(user.value);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    watch(isAuthenticated, function (newValue, oldValue) {
      if (newValue === oldValue) return;
      if (!newValue) {
        removeCustomerGroup();
      } else {
        var _user$value;
        setCustomerGroup((_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.customerGroup);
      }
    });
    useHead(function () {
      var _meta$link;
      var meta = getMeta();
      var link = (_meta$link = meta.link) !== null && _meta$link !== void 0 ? _meta$link : [];
      if (!errored.value && !link.find(function (link) {
        return link.rel === 'canonical';
      })) {
        link.push({
          rel: 'canonical',
          href: getCanonicalUrl()
        });
      }
      return _objectSpread(_objectSpread({
        title: 'Aroma-Zone'
      }, meta), {}, {
        link: link
      });
    });
    return {
      errored: errored,
      getCanonicalUrl: getCanonicalUrl,
      getMeta: getMeta,
      route: route
    };
  }
});